// Redirects für alle alten WordPress-URLs (dickies-helden.de) → neue App-Routen.
// Quelle: WordPress-Sitemaps + Google-Ads-/Search-Console-Daten (Juni 2026).
// Vollständige Migrations-Tabelle: /app/memory/ads-migration.md
import { Navigate, useParams } from "react-router-dom";

export const LEGACY_REDIRECTS = [
  // --- Google-Ads-Top-URLs (LG1/LG2-Kampagne) ---
  { from: "/lg1-lg2-copy", to: "/lg1-lg2" },
  { from: "/pflege-lg1-2", to: "/lg1-lg2" },

  // --- Zielgruppen- & Angebotsseiten ---
  { from: "/pflege", to: "/pflegekraefte" },
  { from: "/pflegehelfer", to: "/kurse/pflegehelfer-qn2" },
  { from: "/pdl", to: "/kurse/pdl" },
  { from: "/job-pdl", to: "/kurse/pdl" },
  { from: "/consulting", to: "/pflegedienste" },
  { from: "/pflegedienst-foerderung", to: "/pflegedienste" },
  { from: "/foerderungen", to: "/weiterbildung-pflege" },
  { from: "/gefoerderte-weiterbildung", to: "/weiterbildung-pflege" },
  { from: "/kursmodelle", to: "/#kurse" },
  { from: "/akademie", to: "/" },
  { from: "/karriere", to: "/pflegekraefte" },

  // --- Info & Kontakt ---
  { from: "/ueberuns", to: "/#team" },
  { from: "/kontakt", to: "/#kontakt" },
  { from: "/telefon-kontakt", to: "/#kontakt" },
  { from: "/faq", to: "/#faq" },
  { from: "/infos", to: "/#faq" },
  { from: "/news", to: "/leitfaeden" },

  // --- Account / Checkout (WooCommerce / LearnDash) ---
  { from: "/login", to: "/campus/login" },
  { from: "/b2b-login", to: "/campus/login" },
  { from: "/b2b-registrierung", to: "/campus/login" },
  { from: "/mein-konto", to: "/campus/login" },
  { from: "/meine-kurse", to: "/campus/login" },
  { from: "/reset-password", to: "/forgot-password" },
  { from: "/passwort-zuruecksetzen", to: "/forgot-password" },
  { from: "/checkout", to: "/#kurse" },
  { from: "/warenkorb", to: "/#kurse" },

  // --- Shop (physische Produkte gibt es im neuen Shop noch nicht) ---
  { from: "/pflegeshop", to: "/shop" },
  { from: "/shop-lehrbuecher", to: "/shop" },
  { from: "/shop-workbooks", to: "/shop" },
  { from: "/shop-utensilien", to: "/shop" },

  // --- Blog-Artikel (organische Rankings) ---
  { from: "/bewerbungsgespraech", to: "/pflegekraefte" },
  { from: "/vorstellungsgespraech-tipps-vorbereitung-ablauf-und-typische-fragen", to: "/pflegekraefte" },
  { from: "/die-vorteile-der-arbeit-in-der-pflegebranche-warum-pflegeberufe-lohnenswert-sind", to: "/pflegekraefte" },
  { from: "/die-bedeutung-kontinuierlicher-weiterbildung-in-der-pflege-eine-investition-in-die-patientenversorgung", to: "/pflegekraefte" },
  { from: "/investition-in-persoenliches-und-berufliches-wachstum", to: "/pflegekraefte" },
  { from: "/hygiene-in-der-pflege", to: "/leitfaeden" },
  { from: "/weiterbildung-in-der-pflege-lg1-und-lg2-dein-schluessel-zu-einer-erfolgreichen-karriere", to: "/lg1-lg2" },
  { from: "/lg1lg2-ohne-berufserfahrung-ambulanter-pflegeassistent", to: "/kurse/ambulanter-pflegeassistent" },
  { from: "/weiterbildung-in-der-behandlungspflege-lg3-lg4-fuer-pflegehelfer-pflege-und-alltagsassistenten", to: "/kurse/pflegeassistent-lg1-lg2" },
  { from: "/weiterbildung-zur-pflegedienstleitung-deine-pflege-karriere-auf-ein-neues-level-bringen", to: "/kurse/pdl" },
  { from: "/wundexperte-karrierechancen-weiterbildung", to: "/kurse/wundexperte" },
  { from: "/gerontopsychiatrie-fur-pflegekrafte-eine-essentielle-weiterbildung", to: "/kurse/gerontopsychiatrische-fachweiterbildung" },
  { from: "/praxisanleiter-amp-die-rezertifizierung", to: "/kurse/rezert-praxisanleitung" },

  // --- Danke-/System-Seiten ---
  { from: "/danke-kontakt", to: "/" },
  { from: "/danke-pflegedienst", to: "/" },
  { from: "/danke-pflegekraft", to: "/" },
  { from: "/vielen-dank-fuer-deine-bestellung", to: "/" },
  { from: "/registration-success", to: "/campus/login" },
  { from: "/wholesale-thank-you-page", to: "/" },
  { from: "/test", to: "/" },
];

// WooCommerce-Produkt-Slugs → neue Seiten (Slugs werden URL-dekodiert verglichen)
const PRODUCT_REDIRECTS = {
  "pflegeassistent-nach-lg1-lg2": "/kurse/pflegeassistent-lg1-lg2",
  "weiterbildung-palliativ-care": "/kurse/palliativ-care",
  "palliativbegleiter-mit-kim-meiritz-buchautoren-und-palliativspezialistin": "/palliativ",
  "rezertifizierung-betreuungskraft-nach-§43c-sgb-xi": "/kurse/rezert-betreuungskraft",
  "pflichtfortbildungen": "/pflichtfortbildungen",
  "pflichfortbildungen": "/pflichtfortbildungen",
  "weiterbildung-chronische-und-schwer-heilende-wunden": "/kurse/wundexperte",
  "grundlagen-der-betreuung-und-alltagsbegleitung": "/kurse/grundlagen-betreuung",
  "pflegehelfer-qn2": "/kurse/pflegehelfer-qn2",
  "ambulanter-pflegeassistent": "/kurse/ambulanter-pflegeassistent",
  "praxisanleiter-m-w-d": "/kurse/praxisanleitung",
  "berufsspezifisches-deutsch-fuer-pflegehelfer": "/kurse/deutsch-pflegehelfer",
  "wundexperte": "/kurse/wundexperte",
  "pflegedienstleitung": "/kurse/pdl",
  "rezertifizierung-praxisanleitung": "/kurse/rezert-praxisanleitung",
  "lg1-lg2-lernpaket": "/shop/richtig-abrechnen",
  "utensilien": "/shop/richtig-abrechnen",
  "workbook-pflegeprozesse": "/shop/richtig-abrechnen",
};

/** Fängt /product/:slug und /produkt/:slug ab (inkl. §-Sonderzeichen-Slugs). */
export function ProductRedirect() {
  const { slug } = useParams();
  const decoded = decodeURIComponent(slug || "");
  let target = PRODUCT_REDIRECTS[decoded];
  if (!target && decoded.startsWith("betreuungskraft-nach-")) target = "/kurse/betreuungskraft";
  return <Navigate to={target || "/#kurse"} replace />;
}
